import script from "./SubmissionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionsPage.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionsPage.vue?vue&type=style&index=0&id=4e21c182&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e21c182"]])

export default __exports__